import React, { useCallback, useState } from 'react';
import TeamSelectorArg from '../../components/TeamSelector/TeamSelectorArg';
import PlayerCombinerArg from '../../components/PlayerCombiner/PlayerCombinerArg';
import clubsArg from '../../data/clubsArg.json';
import Title from '../../components/Title/Title';
import { FORMATIONS, randomFormationName } from '../../helpers/formations';
import './SquadPage.css';

const SquadPageArg = () => {
    const [selectedTeam, setSelectedTeam] = useState('');
    const [randomTeam, setRandomTeam] = useState('');
    const [formation, setFormation] = useState('');
    const [resetKey, setResetKey] = useState(0);

    // La formación se sortea UNA vez, al elegir el club (antes vivía en un
    // FormationGenerator con un useEffect que podía re-dispararse a mitad de partida).
    const handleTeamSelect = (team) => {
        setSelectedTeam(team);
        const otherTeams = Object.keys(clubsArg).filter((t) => t !== team);
        setRandomTeam(otherTeams[Math.floor(Math.random() * otherTeams.length)]);
        setFormation(randomFormationName());
    };

    const handleResetGame = useCallback(() => {
        setSelectedTeam('');
        setRandomTeam('');
        setFormation('');
        setResetKey((prev) => prev + 1);
    }, []);

    return (
        <div className="b11-page">
            <Title />
            {!selectedTeam || !formation ? (
                <TeamSelectorArg key={resetKey} onSelect={handleTeamSelect} />
            ) : (
                <PlayerCombinerArg
                    key={`${selectedTeam}-${resetKey}`}
                    selectedTeam={selectedTeam}
                    randomTeam={randomTeam}
                    positions={FORMATIONS[formation]}
                    formationName={formation}
                    onResetGame={handleResetGame}
                />
            )}
        </div>
    );
};

export default SquadPageArg;
